/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AdminService } from './services/admin.service';
import { AdminLogService } from './services/admin-log.service';
import { UserService } from './services/user.service';
import { StorageService } from './services/storage.service';
import { OAuthService } from './services/o-auth.service';
import { GoogleService } from './services/google.service';
import { KakaoService } from './services/kakao.service';
import { NaverService } from './services/naver.service';
import { SettingService } from './services/setting.service';
import { MemoService } from './services/memo.service';
import { UserActionLogService } from './services/user-action-log.service';
import { BannerService } from './services/banner.service';
import { PlaceService } from './services/place.service';
import { VideoService } from './services/video.service';
import { FeedService } from './services/feed.service';
import { TagService } from './services/tag.service';
import { PickService } from './services/pick.service';
import { CommentService } from './services/comment.service';
import { BusinessInfoService } from './services/business-info.service';
import { TermService } from './services/term.service';
import { LikeService } from './services/like.service';
import { ReportService } from './services/report.service';
import { CategoryService } from './services/category.service';
import { NoticeService } from './services/notice.service';
import { FaqService } from './services/faq.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AdminService,
    AdminLogService,
    UserService,
    StorageService,
    OAuthService,
    GoogleService,
    KakaoService,
    NaverService,
    SettingService,
    MemoService,
    UserActionLogService,
    BannerService,
    PlaceService,
    VideoService,
    FeedService,
    TagService,
    PickService,
    CommentService,
    BusinessInfoService,
    TermService,
    LikeService,
    ReportService,
    CategoryService,
    NoticeService,
    FaqService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
